module.exports = __webpack_public_path__ + "media/1_3-57.a00c5e01.mp3";